import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import { Settings } from 'luxon'

import './index.css'
import '@pandiafi/components/assets/index.css'

import { queryClient } from 'reactQuery'
import './i18n/i18n'
import { syncLanguageAttribute } from 'utils/syncLanguageAttribute'
import { Router } from 'router'
import TrackingConsentManager from 'components/TrackingConsentManager/TrackingConsentManager'

Settings.defaultZone = 'Europe/Helsinki'

syncLanguageAttribute()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <TrackingConsentManager />
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  </React.StrictMode>
)
